import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import LocalService from '../../../../../services/local-auth';
import SecretariaService from '../../../../../services/secretaria';
import Local from './local';


const ListarLocal = () => {

    const [locais, setLocs] = useState([]);
    const [editar, setEditar] = useState("");
    const [vazio, setVazio] = useState(false);
    const [secretarias, setSecretarias] = useState([]);
    const [local, setLoc] = useState("");

    const montaSec = async () => {
        const secs = await SecretariaService.listar()
        setSecretarias(secs.data)
    }

    async function fetchLocais() {
        await montaSec()
        const response = await LocalService.listar();
        if (response.data.length >= 1) {
            setLocs(response.data)
            setVazio(false)
        } else {
            setLocs([])
            setVazio(true)
        }
    }

    const handleEditar = (id) => {
        setLoc(id);
        setEditar(true)
    }


    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar o Órgão?')) {
            await LocalService.deletarLocais(id)
            alert("Órgão deletado com sucesso!")
            fetchLocais();
        }
    }

    useEffect(() => {
        fetchLocais();
    }, []);



    if (editar) {
        return (
            <Navigate to={`/restrito/institucional/locais/editar/${local}`} />
        )
    }
    else {
        return (
            <Fragment>
                <Fragment>
                    <FormBusca
                        setLocs={setLocs}
                        setVazio={setVazio}
                        fetchLocais={fetchLocais}
                        secretarias={secretarias}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                </Fragment> :
                    <Fragment>
                        <Row xs={3}>
                            {locais.map((local, index) =>
                                <Local
                                    fetchLocais={fetchLocais}
                                    local={local}
                                    key={index}
                                    editar={handleEditar}
                                    deletar={deletar}
                                />
                            )}
                        </Row>
                    </Fragment>}
            </Fragment>

        )
    }
}

export default ListarLocal;